import React from "react";
import { Column, Lookup } from "devextreme-react/data-grid";

/**
 * Renders a column-definition array as DevExtreme `<Column>` elements.
 *
 * Both panes' grids take their columns as data rather than as markup - the bottom pane has thirteen
 * grids and the top three, and every one of them differs only in which column set it binds. This is
 * the one place that turns a definition into an element, so the two panes cannot drift apart on how
 * a `lookup` or a `hidden` flag is honoured (Architecture.md R1).
 *
 * @param {Array} columns definitions: { dataField, caption, dataType, format, customizeText,
 *                        visible, lookup, hidden }. `hidden: true` means a key or foreign key -
 *                        never shown and never offered in the column chooser (Architecture.md
 *                        rule 8). `visible: false` means available from the chooser but off by
 *                        default.
 */
export const renderColumns = (columns) =>
    columns.map((column) => (
        <Column
            key={column.dataField}
            dataField={column.dataField}
            caption={column.caption}
            dataType={column.dataType}
            format={column.format}
            customizeText={column.customizeText}
            visible={column.hidden ? false : column.visible !== false}
            showInColumnChooser={!column.hidden}
        >
            {column.lookup && <Lookup dataSource={column.lookup} displayExpr="text" valueExpr="id" />}
        </Column>
    ));
